import { render, staticRenderFns } from "./DocumentDisplayItem.vue?vue&type=template&id=8767a426&scoped=true"
import script from "./DocumentDisplayItem.vue?vue&type=script&lang=ts"
export * from "./DocumentDisplayItem.vue?vue&type=script&lang=ts"
import style0 from "./DocumentDisplayItem.vue?vue&type=style&index=0&id=8767a426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8767a426",
  null
  
)

export default component.exports